import React, {useEffect, useMemo, useState} from "react";
import {IssueFiltersPaginatedQuery, useGetIssuesQuery, useGetIssuesViaElasticSearchQuery} from "@mwServices/Issue";
import {IssueGrid} from "@components/grid";
import {IssuesListItem} from "@mwPages/issues/index";
import {PAGINATION_NONE} from "@components/grid/Grid";
import usePreferences from "@hooks/usePreferences";


const SingleResultIssueVariants = ({
                                     issue,
                                     showValueRibbon,
                                     showDesktopView,
                                     showEditMultiple,
                                     toggleSelected,
                                     windowDimensions,
                                     setAddToCollectionIds,
                                     selectedComicIds,
                                     listViewColumns,
                                     shopLink,
}) => {

    const variantOf = useMemo(() => {
        if(issue && issue.variant_of) return issue.variant_of;
        if(issue && issue.id) return issue.id;
        return 0;
    }, [issue]);

    const isMainCover = useMemo(() => {
        return (issue && issue.variant_of === null);
    }, [issue]);

    const [issueParams, setIssueParams] = useState<IssueFiltersPaginatedQuery>({
        filters: { variantOf: variantOf },
        page: 1,
        perPage: 500,
    });

    useEffect(() => {
        setIssueParams({
            filters: { variantOf: variantOf },
            page: 1,
            perPage: 500,
        });
    }, [variantOf]);

    const issueQuery = useGetIssuesViaElasticSearchQuery(issueParams);

    const {issueData, pagination}  = useMemo(() => {
        if(issueQuery.data && issueQuery.data.issues){

            issueQuery.data = {
                ...issueQuery.data,
                issues: issueQuery.data.issues.filter(item => ''+item.id !== ''+issue.id),
            };

            return {
                issueData: issueQuery.data,
                pagination: issueQuery.data.pagination,
            };
        }

        return { issueData: null, pagination: null };
    }, [issueQuery]);

    const showResults = pagination && pagination.total_items;

    const mainCoverParams = useMemo(() => ({
        filters: { issueIds: [variantOf] },
        page: 1,
        perPage: 1,
    }), [variantOf]);

    const mainCoverQuery = useGetIssuesQuery(mainCoverParams);

    const mainCoverIssueData  = useMemo(() => {
        if(mainCoverQuery.data && mainCoverQuery.data.issues && mainCoverQuery.data.issues.length === 1) return mainCoverQuery.data.issues[0];
        return null;
    }, [mainCoverQuery]);

    return showResults ? (
        <div className={"mar-top-10"}>
            {!isMainCover && mainCoverIssueData && (
                <>
                    <div className={"variant-covers-title"}>
                        Main Cover
                    </div>
                    <IssuesListItem
                        item={mainCoverIssueData}
                        key={mainCoverIssueData.id}
                        showValueRibbon={showValueRibbon}
                        showDesktopView={showDesktopView}
                        showEditMultiple={showEditMultiple}
                        isSelected={selectedComicIds.indexOf(mainCoverIssueData.id) !== -1}
                        listViewColumns={listViewColumns}
                        toggleSelected={toggleSelected}
                        windowDimensions={windowDimensions}
                        setAddIssueId={(issueId) => setAddToCollectionIds(issueId ? [issueId] : [])}
                        shopLink={shopLink}
                    />
                </>
            )}

            <div className={"variant-covers-title"}>
                Variant Covers ({pagination && pagination.total_items})
            </div>

            <IssueGrid
                isListGrid={true}
                isLoading={issueQuery.isLoading || issueQuery.isFetching}
                data={issueQuery.data}
                noDataMessage="There are no issues matching this search."
                IssueRender={(props) =>
                    (<>
                        <IssuesListItem
                            {...props}
                            toggleSelected={toggleSelected}
                            windowDimensions={windowDimensions}
                            setAddIssueId={(issueId) => setAddToCollectionIds(issueId ? [issueId] : [])}
                        />
                    </>)}
                getItemProps={(item) => ({
                    key: item.id,
                    showValueRibbon,
                    showDesktopView,
                    showEditMultiple,
                    isSelected: selectedComicIds.indexOf(item.id) !== -1,
                    listViewColumns: listViewColumns,
                    shopLink: shopLink
                    ? {
                        ...shopLink,
                        link_url: shopLink.link_url.replace(
                            "#cp_issue_title#",
                            encodeURIComponent(`${item.series_title} ${item.issue_number}`)
                        ),
                    }
                    : undefined,
                })}
                paginationType={PAGINATION_NONE}
            />
        </div>
    ) : (<></>);
}

export default SingleResultIssueVariants;